(function($){
    // JS
    window.Forms = {

        // Google Tag Manager Data Layer - Contact form #form_contact
        //======================================================================
        contactDataLayer: function() {
             
			/*
				//Testing
				if(dataLayer) {
					console.log('dataLayer available');
				}
			*/

			//Form ID
			var formElement = '#form_contact';		//The form
			var formName = 'subscribe';				//Data to be passed to the Datalayer as 'formName'

			//If form ID 'exampleid' has been submitted
			$(formElement).submit(function (e) {

				//Push Data Layer event
				dataLayer.push({
					'event': 'formSubmit',
					'formName': formName
				}); 
			});

        }

    }

    // Run
    $(function(){
        Forms.contactDataLayer();
    });


}(jQuery));